import type { IMsalContextExtended } from '@festina-life/authentication'
import type { Currency, Language } from '@festina-life/core'
import { createContext, useContext } from 'react'

export type SettingsContextType = {
  language: Language
  isInDebugMode: boolean
  changeDebugMode: (isInDebugMode: boolean) => void
  changeLanguage: (nextLanguage: Language) => void
  currency: Currency
  availableLanguages: Language[]
  authState: IMsalContextExtended
}

/** Configuration context for a life App. */
const SettingsContext = createContext<SettingsContextType | null>(null)

const useSettingsContext = () => {
  const context = useContext(SettingsContext)

  if (!context) {
    throw new Error(
      'You must wrap your app in a SettingsProvider to use the SettingsContext',
    )
  }

  return context
}

const useOptionalSettingsContext = () => {
  const context = useContext(SettingsContext)

  return (context ?? {}) as Partial<SettingsContextType>
}

const Provider = SettingsContext.Provider

export { Provider, useOptionalSettingsContext, useSettingsContext }
